import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/jss/SearchResultGroupTab";
import SearchResultGroupCard from "../SearchResultGroupCard/SearchResultGroupCard";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";

export default function SearchResultGroupTab(props) {
  const classes = useStyles();
  const [searchResultData, setSearchResultData] = useState(null);
  useEffect(() => {
    setSearchResultData(props.searchResultData);
  }, [props.searchResultData]);
  return (
    <>
      <CustomBox>
        <CustomGrid container spacing={3}>
          {searchResultData && searchResultData.length
            ? searchResultData.map((group, index) => {
                return (
                  <CustomGrid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    key={`${group.groupId}-${index}-${Math.floor(
                      Math.random() * 101
                    )}`}
                  >
                    <SearchResultGroupCard groupData={group} />
                  </CustomGrid>
                );
              })
            : null}
        </CustomGrid>
      </CustomBox>
    </>
  );
}
